var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 6C7.99998 6.1435 7.96945 6.28269 7.90838 6.41758C7.84731 6.55247 7.76588 6.66439 7.6641 6.75336L2.0458 11.704C1.82188 11.9013 1.53689 12 1.19084 12C0.844781 12 0.559795 11.9013 0.335877 11.704C0.111959 11.5067 0 11.2556 0 10.9507C0 10.6457 0.111959 10.3946 0.335877 10.1973L5.09923 6L0.335877 1.80269C0.111959 1.60538 0 1.35426 0 1.04933C0 0.744395 0.111959 0.493275 0.335877 0.295965C0.559795 0.0986557 0.844781 0 1.19084 0C1.53689 0 1.82188 0.0986557 2.0458 0.295965L7.6641 5.24664C7.78624 5.35426 7.87296 5.47085 7.92426 5.59641C7.97555 5.72197 8.0008 5.8565 7.99998 6Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.c78b67c41a66ec17e60140557ba3ee00.svg";
export { ForwardRef as ReactComponent };